import React from 'react';

interface ConfigErrorProps {
  message: string;
}

export const ConfigError: React.FC<ConfigErrorProps> = ({ message }) => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: '20px',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    backgroundColor: '#1a1a1a',
    color: '#fff'
  }}>
    <h1 style={{ color: '#ef4444', marginBottom: '16px' }}>Configuration Error</h1>
    <p style={{ maxWidth: '600px', textAlign: 'center', lineHeight: 1.6 }}>
      {message}
    </p>
    <p style={{ marginTop: '24px', color: '#888' }}>
      Check the browser console for details.
    </p>
  </div>
);
